import React, { FC } from 'react'
import styled from 'styled-components'
import { KVMeasurement } from 'types'

import { MeasurementLabelInput } from './MeasurementLabelInput'
import { MeasurementSegmentsList } from './MeasurementSegmentsList'

const MeasurementSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  width: 100%;
  height: 150px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`

export const MeasurementMenu: FC<{
  selectedMeasurement: KVMeasurement
}> = ({ selectedMeasurement }) => {
  return (
    <>
      <MeasurementLabelInput selectedMeasurement={selectedMeasurement} />
      <MeasurementSection>
        <MeasurementSegmentsList selectedMeasurement={selectedMeasurement} />
      </MeasurementSection>
    </>
  )
}
